import { PropsWithChildren, useState } from 'react';
import { BaseKey } from '@refinedev/core';
import { Button } from 'antd';
import { fetcher } from '../../utils/fetcher';

type Props = {
  userId?: BaseKey;
  path?: string;
};

export const ImpersonateButton = ({ userId, path, children }: PropsWithChildren<Props>) => {
  const [isLoading, setIsLoading] = useState(false);

  const impersonate = async () => {
    setIsLoading(true);
    const response = await fetcher(`/admin/users/${userId}/impersonate`);
    const data = (await response.json()) as { redirect_url: string };
    window.open(`${data.redirect_url}${path ? `&path=${path}` : ''}`);
    setIsLoading(false);
  };

  return (
    <Button onClick={impersonate} loading={!userId || isLoading}>
      {children || 'ログイン'}
    </Button>
  );
};
